export default __webpack_public_path__ + "static/og-f6a93f94c699b3c62c80d286688df717.png";